import { Box, Typography, Button, Grid, ListItem, ListItemText, List, Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import {
    LineChart,
    lineElementClasses,
    markElementClasses,
} from '@mui/x-charts/LineChart';
import { Link } from 'react-router-dom';

const uData = [4000, 3000, 2000, 2780, 1890, 2390, 3490];
const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
const xLabels = [
    'Page A',
    'Page B',
    'Page C',
    'Page D',
    'Page E',
    'Page F',
    'Page G',
];

function AdminPanel() {
    const activeUsers = 35; // Example number of active users, can be dynamic
    const [supplierList, setSupplierList] = useState([]);
    const GetAllSupplierDetails = () => {
        axios.get('https://serverrion.mylksystems.store/Suppliers/getsuppliers')
            .then((res) => {
                if (res.data.length > 0) {
                    setSupplierList(res.data);
                } else {
                    setSupplierList([]);
                    toast.error("No records to display!");
                    //console.log
                    console.log(res.data);
                }
            })
            .catch((error) => {
                toast.error("Failed to fetch supplier data.");
            });
    };

    const username = sessionStorage.getItem('username')

    // Fetch supplier data when the component is mounted
    useEffect(() => {
        GetAllSupplierDetails();
    }, []);

    return (
        <Box sx={{ display: 'flex', height: '100vh', backgroundColor: '#f4f4f4' }}>
            {/* Sidebar */}
            <Box
                sx={{
                    width: '250px',
                    marginTop: '65px',
                    backgroundColor: '#000000',
                    color: 'white',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    padding: '20px',
                }}
            >
                {/* Logo Section */}
                <Box sx={{ textAlign: 'center' }}>
                  
                    <Typography variant="h6" sx={{ marginTop: '10px' }}>
                        Admin Panel
                    </Typography>
                </Box>

                {/* Menu Items */}
                <Box>
                    <List>
                        <Link to="/UserManagement" style={{ textDecoration: 'none', color: 'inherit' }}>
                            <ListItem button>
                                <ListItemText primary="Users" />
                            </ListItem>
                        </Link>
                        <ListItem button>
                            <ListItemText primary="Dashboard" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="Users" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="Settings" />
                        </ListItem>
                        <ListItem button>
                            <ListItemText primary="Logout" />
                        </ListItem>
                    </List>
                </Box>
            </Box>

            {/* Main Content Area */}
            <Box
                sx={{
                    flex: 1,
                    backgroundColor: 'white',
                    padding: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '70px'
                }}
            >
                {/* Header */}
                <Typography variant="h5" sx={{ textAlign: 'left' }}>Welcome {username}!!</Typography>
                <Typography variant="h4" sx={{ textAlign: 'center' }}>Admin Panel</Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}
                >

                    {/* <Button variant="contained" color="primary">
                        Add New Item
                    </Button> */}
                </Box>

                {/* Main Content */}
                <Grid container spacing={2}>
                    {/* Active Users Box */}
                    <Grid item xs={6}
                        sx={{
                            // height:'100%'
                        }}>
                        <Box
                            sx={{
                                backgroundColor: '#37B7C3',
                                color: 'white',
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                height: '55%',
                                margin: '20px'
                            }}
                        >
                            <Typography variant="h4" sx={{ marginBottom: '10px', color: 'black' }}>
                                Suppliers
                            </Typography>
                            <Typography variant="h4">

                                {supplierList.length > 0 ? (
                                    <TableContainer sx={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Supplier Name</TableCell>
                                                    <TableCell>Contact No</TableCell> {/* Add more headers if needed */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {supplierList.map((supplier, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{supplier.SupplierName}</TableCell> {/* Adjust to your actual data structure */}
                                                        <TableCell>{supplier.ContactNo}</TableCell> {/* Adjust to your actual data structure */}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ) : (
                                    <Typography>No active suppliers to display</Typography>
                                )}
                            </Typography>
                            {/* <Button variant="contained" color="primary" alignItems="start">
                                View All
                            </Button> */}
                        </Box>
                        <Box
                            sx={{
                                backgroundColor: '#7FA1C3',
                                color: 'white',
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                // height: '100%',
                                margin: '20px'
                            }}
                        >
                            <Typography variant="h4" sx={{ marginBottom: '10px', color: 'black' }}>
                                Sales
                            </Typography>
                            <BarChart
                                series={[
                                    { data: [35, 44, 24, 34] },
                                    { data: [51, 6, 49, 30] },
                                    { data: [15, 25, 30, 50] },
                                    { data: [60, 50, 15, 25] },
                                ]}
                                height={290}
                                xAxis={[{ data: ['June', 'July', 'August', 'September'], scaleType: 'band' }]}
                                // yAxis= { {label: 'rainfall (mm)' }}
                                margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
                            />
                        </Box>
                    </Grid>

                    {/* Welcome Message Box */}
                    <Grid item xs={6}>
                        <Box
                            sx={{
                                backgroundColor: '#7FA1C3',
                                color: 'white',
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                // height: '100%',
                                margin: '20px'
                            }}
                        >
                            <Typography variant="h4" sx={{ marginBottom: '10px', color: 'black' }}>
                                Animal Type
                            </Typography>
                            <PieChart
                                series={[
                                    {
                                        data: [
                                            { id: 0, value: 10, label: 'Dog' },
                                            { id: 1, value: 15, label: 'Cat' },
                                            { id: 2, value: 20, label: 'Parrot' },
                                            { id: 3, value: 20, label: 'Rabbit' },
                                        ],
                                    },
                                ]}
                                width={400}
                                height={300}
                                padding={10}
                            />
                        </Box>
                        <Box
                            sx={{
                                backgroundColor: '#7FA1C3',
                                color: 'white',
                                borderRadius: '8px',
                                padding: '20px',
                                textAlign: 'center',
                                // height: '100%',
                                margin: '20px'
                            }}
                        >
                            <Typography variant="h4" sx={{ marginBottom: '10px', color: 'black' }}>
                                Medicines
                            </Typography>
                            <LineChart
                                // width=
                                height={300}
                                series={[
                                    { data: pData, label: 'pv', id: 'pvId' },
                                    { data: uData, label: 'uv', id: 'uvId' },
                                ]}
                                xAxis={[{ scaleType: 'point', data: xLabels }]}
                                sx={{
                                    [`.${lineElementClasses.root}, .${markElementClasses.root}`]: {
                                        strokeWidth: 4,
                                    },
                                    '.MuiLineElement-series-pvId': {
                                        strokeDasharray: '5 5',
                                    },
                                    '.MuiLineElement-series-uvId': {
                                        strokeDasharray: '3 4 5 2',
                                    },
                                    [`.${markElementClasses.root}:not(.${markElementClasses.highlighted})`]: {
                                        fill: 'white',
                                    },
                                    [`& .${markElementClasses.highlighted}`]: {
                                        stroke: 'none',
                                    },
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default AdminPanel;
